/**
 * autoNumeric Component
 *
 * @file custom autoNumeric.js
 */

// import AutoNumeric from 'autonumeric';
import $ from "jquery";



const inputMoney = (() => {
  const defaultinputMoney = () => {
    // var inputs = document.querySelectorAll('.calculate-number-inp');
    // inputs.forEach(function(input) {
    //   new AutoNumeric(input, {
    //     currencySymbol: '', // Para birimi simgesi olarak Türk Lirası simgesi
    //     currencySymbolPlacement: 's', // Para birimi simgesinin başa geleceğini belirtir
    //     digitGroupSeparator: '.', // Binlik ayırıcı
    //     decimalCharacter: ',', // Ondalık ayırıcı
    //     decimalPlaces: 0, // Ondalık basamak sayısı
    //     minimumValue: 0, // Minimum değeri belirtin
    //     maximumValue: 10000000, // Maksimum değeri belirtin (10 milyon TL) 
    //     unformatOnSubmit: true,
    //   });
    // });
  };

  const slideRange = () => {
    document.addEventListener("DOMContentLoaded", function() {
      const rangeInputs = document.querySelectorAll('.range-to-up-calc');
    
      rangeInputs.forEach(rangeInput => {
        const startDiv = rangeInput.parentElement.querySelector('.calc-start');
        const stopDiv = rangeInput.parentElement.querySelector('.calc-stop');
    
        // Başlangıç ve bitiş değerlerini güncelle
        startDiv.textContent = rangeInput.min;
        stopDiv.textContent = rangeInput.max;
    
        // Input değeri değiştiğinde div içeriklerini güncelle
        rangeInput.addEventListener('input', function() {
          startDiv.textContent = this.value;
        });
      });
    });
  };

  const slideRangeNumber = () => {
    // document.addEventListener("DOMContentLoaded", function() {
    //   var inputContainer = document.querySelectorAll('.c-form-calc-inp');

    //   inputContainer.forEach(function(inputContainer) {
    //     // Giriş alanlarına eriş
    //     var inp = inputContainer.querySelector('.calculate-inp');
    //     var range = inputContainer.querySelector('.range-to-number-calc');
    
    //     // Giriş alanlarının değerlerini senkronize et
    //     var inpNumeric = new AutoNumeric(inp, {
    //         currencySymbol: '', // Para birimi simgesi olarak Türk Lirası simgesi
    //         currencySymbolPlacement: 's', // Para birimi simgesinin başa geleceğini belirtir
    //         digitGroupSeparator: '.', // Binlik ayırıcı
    //         decimalCharacter: ',', // Ondalık ayırıcı
    //         decimalPlaces: 0, // Ondalık basamak sayısı
    //         minimumValue: 0, // Minimum değeri belirtin
    //         maximumValue: 10000000, // Maksimum değeri belirtin (10 milyon TL) 
    //         unformatOnSubmit: true,
    //     });
    
    //     // Giriş alanlarının değerlerini senkronize et
    //     inp.addEventListener('input', function() {
    //         var inputValue = inpNumeric.getNumber();
    //         // 7 haneli sayıya uygun olacak şekilde formatlayalım
    //         range.value = ("0000000" + inputValue).slice(-7); // 7 haneli olacak şekilde düzenleme
    //     });
    
    //     range.addEventListener('input', function() {
    //         inpNumeric.set(range.value);
    //     });
    //   });
    // });
  };

  const rateInputOnlyNumber = () => {
    var rateCheckbox = document.querySelectorAll('.checkProfitRateCheckbox');
    var rateInput = document.getElementById('checkProfitRateInput');
    if($(".checkProfitRateCheckbox").is(":visible")){
      rateCheckbox.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
          if (this.checked) { 
            rateInput.readOnly = false; 
            rateInput.focus();
          } else {
            rateInput.readOnly = true; 
            rateInput.value = "";
          }
        });
      });
      document.getElementById('checkProfitRateInput').addEventListener('input', function(event) {
        // Sayfa dilini kontrol et
        var lang = document.documentElement.lang;
    
        if (lang === 'tr') {
            // Türkçe dilinde sadece sayı ve nokta işaretine izin ver
            this.value = this.value.replace(/[^0-9.]/g, '');
        } else if (lang === 'en') {
            // İngilizce dilinde sadece sayı ve virgül işaretine izin ver
            this.value = this.value.replace(/[^0-9,]/g, '');
        }
      });
      // rateInput.addEventListener('input', function() {
      //   var value = rateInput.value.replace(/\D/g, '');
      //   if (value.length > 2) { 
      //     rateInput.value = value.substring(0, value.length - 2) + ',' + value.substring(value.length - 2); 
      //   } else { 
      //     rateInput.value = value; 
      //   }
      // });
    }
  };

  const init = () => {
    defaultinputMoney();
    slideRange();
    slideRangeNumber();
    rateInputOnlyNumber();
  };

  return {
    init,
  };
})();

export default inputMoney;
